import { Grid } from '@mui/material';
import { Route, Switch } from 'react-router-dom';
import {FeedbackDetails} from "./FeedbackDetails";
import {FeedbackPage} from "./FeedbackPage";
import { verificationAgency } from '../../../Component/Common/Constants/routes';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';

export const FeedbackBase = () => {

    const [company, setCompany] = useRecoilState(VerificationCompanyAtom);
    
    const resetCurrentApplication = () =>{
        setCompany({...company , feedbackId: -1});
    }

    useEffect(()=>{
        resetCurrentApplication();
    },[]);
    
    const routes = [
        `/${verificationAgency.company}/${verificationAgency.applications}/${verificationAgency.feedback}`,
        `/${verificationAgency.company}/${verificationAgency.applications}/${verificationAgency.feedback}/details`,
    ];

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Switch>
                        <Route exact path={routes[0]}>
                            <FeedbackPage />
                        </Route>
                        <Route exact path={routes[1]}>
                            <FeedbackDetails />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>
    );
}
